import { Provider as ReduxProvider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { PropsWithChildren } from 'react';
// import { ThirdwebProvider } from '@thirdweb-dev/react';
import { Provider } from 'urql';
import { ToastProvider } from '@orionprotocol/ui';

import { store } from '../../shared/redux/store';
import { EnvWrapper } from '../wrappers/EnvWrapper/EnvWrapper';
import { graphqlClient } from '../../shared/api/graphql';

import { LanguageProvider } from './language/LanguageProvider';
import { LumiaProvider } from './LumiaProvider';
import { DialogProvider } from './DialogProvider';
import { TransactionsProcessingProvider } from './TransactionsProcessingProvider';

const queryClient = new QueryClient();

export function Providers({ children }: PropsWithChildren): JSX.Element {
  return (
    <Provider value={graphqlClient}>
      {/* <ThirdwebProvider activeChain={994873017}> */}
      <QueryClientProvider client={queryClient}>
        <ReduxProvider store={store}>
          <EnvWrapper>
            <LumiaProvider>
              <LanguageProvider>
                <ToastProvider>
                  <TransactionsProcessingProvider>
                    <DialogProvider>{children}</DialogProvider>
                  </TransactionsProcessingProvider>
                </ToastProvider>
              </LanguageProvider>
            </LumiaProvider>
          </EnvWrapper>
        </ReduxProvider>
      </QueryClientProvider>
      {/* </ThirdwebProvider> */}
    </Provider>
  );
}
